import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["isOrgOwner", "isOrgUser", "organization"]),

    canUserReonboard() {
      return (
        !_.isEmpty(this.organization) &&
        this.isUserAuthorized("profile") &&
        this.isUserAuthorized("domains") &&
        this.isUserAuthorized("users") &&
        this.isUserAuthorized("teams") &&
        this.isUserAuthorized("members")
      );
    },

    shouldShowCreateTeam() {
      if (this.isUserAuthorized("teams")) {
        return true;
      } else {
        return this.isOrgOwner;
      }
    },
  },

  methods: {
    canOrganizationChangeLongUrl(team = null) {
      if (team === null) {
        return this.isOrganizationAuthorized("change_long_url");
      } else {
        return this.isTeamAuthorized(team, "change_long_url");
      }
    },
    canOrganizationManageTags(team = null) {
      if (team === null) {
        return this.isOrganizationAuthorized("use_tags");
      } else {
        return this.isTeamAuthorized(team, "use_tags");
      }
    },
    canOrganizationManageExpirationDate(team = null) {
      if (team === null) {
        return this.isOrganizationAuthorized("manage_expiration");
      } else {
        return this.isTeamAuthorized(team, "manage_expiration");
      }
    },
    canOrganizationManageRedirection(team = null) {
      if (team === null) {
        return this.isOrganizationAuthorized("redirect_routes");
      } else {
        return this.isTeamAuthorized(team, "redirect_routes");
      }
    },
    canOrganizationArchiveTinyurl(team = null) {
      if (team === null) {
        return this.isOrganizationAuthorized("archive_tiny_url");
      } else {
        return this.isTeamAuthorized(team, "archive_tiny_url");
      }
    },
    canOrganizationDeleteTinyurl(team = null) {
      if (team === null) {
        return this.isOrganizationAuthorized("delete_tiny_url");
      } else {
        return this.isTeamAuthorized(team, "delete_tiny_url");
      }
    },
    canOrganizationShareAnalytics(team = null) {
      if (team === null) {
        return this.isOrganizationAuthorized("share_analytics");
      } else {
        return this.isTeamAuthorized(team, "share_analytics");
      }
    },
    canOrganizationDownloadLogs(team = null) {
      if (team === null) {
        return this.isOrganizationAuthorized("download_logs");
      } else {
        return this.isTeamAuthorized(team, "download_logs");
      }
    },

    isOrganizationAuthorized(feature) {
      const selected = this.organization;
      return selected?.features.includes(feature);
    },
    isTeamAuthorized(team, feature) {
      const selected = this.organization?.teams.find((t) => t.slug == team);
      return selected?.features.includes(feature);
    },
    isUserAuthorized(permission) {
      // owners will be authorized anywhere
      if (this.isOrgOwner) return true;

      // organization user should have the correct permission first
      if (this.isOrgUser) {
        const permissions = this.organization.role.permissions;
        return permissions.some((p) => p.name == permission);
      }

      return false;
    },
  },
};
